module.exports = __webpack_public_path__ + "img/pic_number_60_black.8c6c0361.png";